import { html } from './environment'
import lottie from 'lottie-web'

export default function loadingLogo() {

    const $el = document.getElementById('loadingLogo')

    // Load animation
    const lottieLogo = lottie.loadAnimation({
        container: $el,
        renderer: 'svg',
        loop: false,
        autoplay: false,
        path: $el.dataset.path
    })

    // Events
    lottieLogo.addEventListener('DOMLoaded', onLottieLoaded)
    lottieLogo.addEventListener('complete', onLottieComplete)

    // Play animation
    function onLottieLoaded() {
        lottieLogo.play()
    }

    // Add classes to html
    function onLottieComplete() {
        html.classList.add('is-first-loaded')
        html.classList.add('is-ready')
    }
}
